import { useParams } from "react-router"

const useTreatmentParam = () => {
  const { templateId } = useParams()
  return templateId
}

export { useTreatmentParam }
